import React from "react";
import { Typography } from "../Typography/Typography";
//
import { useFieldErrorMessage } from "../inputUtils";
import type { FieldError } from "react-hook-form";

interface Choice {
  value: string;
  label: string;
}

interface RadioSelectInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  choices: Choice[];
  isRequired: boolean;
  name: string;
  hookFormFieldError: FieldError | undefined;
}

export const RadioSelectInput = React.forwardRef<HTMLInputElement, RadioSelectInputProps>((props, ref) => {
  const { label, choices, isRequired, hookFormFieldError, ...inputProps } = props;

  const error = useFieldErrorMessage(hookFormFieldError);

  return (
    <>
      <Typography className={error ? "text-red" : ""}>
        {props.label}
        {isRequired ? "*" : ""}
      </Typography>
      {error ? <p className="text-red">{error} </p> : null}
      <div className="mt-4">
        {choices.map((choice, idx) => {
          const inputId = `radio-${inputProps.name}-${choice.value}`;
          return (
            <div key={idx} className="flex flex-row">
              <input
                {...inputProps}
                value={choice.value}
                type="radio"
                id={inputId}
                ref={ref}
                className="mr-2 focus:shadow-focus-glow"
              />
              <label htmlFor={inputId}>
                <Typography>{choice.label}</Typography>
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
});

RadioSelectInput.displayName = "RadioSelectInput";
